import React from 'react'
import { StyledVideo as S } from './Video.styles'

export const Video: React.FC = () => {
  return (
    <S.Container>
      <video
        id="background-video"
        width="100%"
        autoPlay
        loop
        playsInline
        muted
        poster="https://cdn-prod-unified-content.gismart.xyz/ee0e4f309c9a47317d3344b5bcd25dcbf0727a91833d5c6e21b842b53c406878/result-page-video-preview.png"
        src="https://cdn-prod-unified-content.gismart.xyz/ee0e4f309c9a47317d3344b5bcd25dcbf0727a91833d5c6e21b842b53c406878/result-page-video.mp4"
      />
    </S.Container>
  )
}
